import { QTableProps } from 'quasar'
import client from './client'
import { Book } from '@/models'

export default {
  /* チェックシートを作成する */
  createBook: (bookadd: {[key: string] : string | null}) => client.post<{ book: { bookHash: string } }>('get_mypage_book_add', { form: { bookadd: bookadd } }).then(({ data }) => data.book),

  /* チェックシートの一覧を取得する */
  listBook: ({ pagination }: { pagination: QTableProps['pagination'] }) =>
    client
      .post<{ resultList: Book[]; pagination: { page: number; rowsNumber: number } }>('get_mypage_book_list', {
        search: { pagination },
      })
      .then(({ data }) => data),
  /* チェックシートを削除する */
  deleteBook: (params: { cd: string }) => client.get('get_mypage_book_del', { params }),
  /* マイページへの表示情報の取得 */
  getData: (params: { cd: string | null}) => client.get('get_mypage_data', { params }).then(({ data }) => data.userTemplateList)
}
